import { render, staticRenderFns } from "./ColumnConfig.vue?vue&type=template&id=5aaaa314&scoped=true&"
import script from "./ColumnConfig.vue?vue&type=script&lang=js&"
export * from "./ColumnConfig.vue?vue&type=script&lang=js&"
import style0 from "./ColumnConfig.vue?vue&type=style&index=0&id=5aaaa314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaaa314",
  null
  
)

export default component.exports